const LOGIN = "LOGIN";
const REGISTER = "REGISTER";
const FUNNEL = "FUNNEL";

export const MODES = {
  LOGIN,
  REGISTER,
  FUNNEL,
};
